import React from 'react';
import PropTypes from 'prop-types';
import ElementSize from '../ElementSize/index.js';
import ProgressIcon from '../lib/ProgressIcon.js';
import withAutomaticColorCalculation from '../lib/withAutomaticColorCalculation.js';

function itemStatus(item) {
  if (item.finishedAt) {
    return "completed";
  }
  return item.unlocked ? "unlocked" : "locked";
}
function SuperbadgeProgress({
  modules,
  content,
  user,
  vertical,
  labels,
  locks
}) {
  const cols = modules.length + 1;
  const bgColor = content.color;
  const gridContainerClassNames = vertical ? "" : `slds-grid slds-grid_align-spread slds-grid_vertical-align-top`;
  const itemPadding = vertical ? "" : "slds-m-top_large";
  const gridColClassNames = vertical ? "" : `slds-col slds-size_1-of-${cols} slds-text-align_center`;
  const renderSuperbadgePrereq = (c, pos) => {
    const itemUser = c.user;
    const itemContent = c.content;
    const status = itemUser && itemUser.finishedAt ? "completed" : "in-progress";
    const testString = `sb_progress-prerequisite_${itemContent.apiName}_${status}`;
    return /*#__PURE__*/React.createElement("div", {
      key: `progress_icon-${itemContent.title}`,
      className: `${gridColClassNames} ${itemPadding}`,
      "data-test": `${testString}`
    }, /*#__PURE__*/React.createElement(ProgressIcon, {
      content: itemContent,
      user: itemUser,
      pos: pos,
      bgColor: bgColor,
      vertical: vertical,
      labels: labels,
      locks: locks
    }));
  };
  const renderSuperbadge = () => {
    const status = user ? itemStatus(user) : "locked";
    const testString = `sb_progress-superbadge_${content.apiName}_${status}`;
    return /*#__PURE__*/React.createElement("div", {
      className: `${gridColClassNames}`,
      "data-test": `${testString}`
    }, /*#__PURE__*/React.createElement(ProgressIcon, {
      content: content,
      user: user,
      pos: "last",
      bgColor: bgColor,
      vertical: vertical,
      labels: labels,
      size: "large",
      locks: locks
    }));
  };
  const renderModules = () => modules.map((c, idx) => {
    const pos = idx === 0 ? "first" : "middle";
    return renderSuperbadgePrereq(c, pos);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "tds-box-shadow_small tds-bg_white slds-p-around_x-large tds-border-radius_medium"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "tds-text-size_8 tds-text_bold slds-p-bottom_medium"
  }, labels.title), /*#__PURE__*/React.createElement("div", {
    className: gridContainerClassNames
  }, renderModules(), renderSuperbadge()));
}
SuperbadgeProgress.displayName = "SuperbadgeProgress";
const defaultProps = {
  user: {},
  vertical: false,
  locks: true
};
const propTypes = {
  content: PropTypes.shape({
    color: PropTypes.string,
    image: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    trailmix: PropTypes.object,
    type: PropTypes.string
  }).isRequired,
  user: PropTypes.shape({
    finishedAt: PropTypes.string
  }),
  modules: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.shape({
      color: PropTypes.string,
      image: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      trailmix: PropTypes.object,
      type: PropTypes.string
    }),
    user: PropTypes.shape({
      finishedAt: PropTypes.string
    })
  })).isRequired,
  vertical: PropTypes.bool,
  labels: PropTypes.shape({
    unlockSuperbadge: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  locks: PropTypes.bool
};
SuperbadgeProgress.defaultProps = defaultProps;
SuperbadgeProgress.propTypes = propTypes;
function SuperbadgeProgressContainer(props) {
  return /*#__PURE__*/React.createElement(ElementSize, null, ({
    width
  }) => {
    if (width > 767) {
      return /*#__PURE__*/React.createElement(SuperbadgeProgress, props);
    }
    return /*#__PURE__*/React.createElement(SuperbadgeProgress, Object.assign({}, props, {
      vertical: true
    }));
  });
}
SuperbadgeProgressContainer.displayName = "SuperbadgeProgressContainer";
const OuterComponent = withAutomaticColorCalculation(SuperbadgeProgressContainer);
OuterComponent.propTypes = propTypes;
OuterComponent.defaultProps = defaultProps;
var OuterComponent$1 = OuterComponent;

export { OuterComponent$1 as default };
